import { required, numeric, maxLength } from 'vuelidate/lib/validators'

const validaDuration = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return /^[0-9]{2}:[0-9]{2}$/g.test(value)
}

export const validateData = {
  form: {
    description: { required, maxLength: maxLength(30) },
    codigo: { required, numeric },
    duration: { required, validaDuration },
  },
}

export const validateComputed = {
  descriptionErrors() {
    const errors = []
    if (!this.$v.form.description.$dirty) return errors
    !this.$v.form.description.required && errors.push('Campo obrigatório.')
    !this.$v.form.description.maxLength && errors.push('Não pode conter mais de 30 caracteres.')
    return errors
  },
  codigoErrors() {
    const errors = []
    if (!this.$v.form.codigo.$dirty) return errors
    !this.$v.form.codigo.required && errors.push('Campo obrigatório.')
    !this.$v.form.codigo.numeric && errors.push('Apenas caracteres numéricos.')
    return errors
  },
  durationErrors() {
    const errors = []
    if (!this.$v.form.duration.$dirty) return errors
    !this.$v.form.duration.required && errors.push('Campo obrigatório.')
    !this.$v.form.duration.validaDuration && errors.push('Formato inválido.')
    return errors
  },
}
